// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e3c9a80","239":"38305d0f","453":"78d7a61a","732":"dd77e65b"}[chunkId] + ".chunk.js";
};